import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {
    RegexTypeInfo,
    ValidationDataMxObj,
    ValidationRegex,
    ValidationType,
    Validator
} from '../../../generated/generated-core.model';

export interface MxValidationManagerService {
    get(): Observable<ValidationDataMxObj>;
    getValidator(type: ValidationType): Validator;
    getRegex(type: ValidationRegex): RegexTypeInfo;
    getRegexes(): string[];
    getClientValidatorTypes(): string[];
    getRegexTypes(): string[];
}
export const MX_VALIDATION_MANAGER_SERVICE_TOKEN = new InjectionToken<MxValidationManagerService>('MX_VALIDATION_MANAGER_SERVICE_TOKEN');
